import {Request} from '../../../request.abstract';
import {Http} from '@angular/http';
import {Settings} from '../../../settings.model';
import {Observable} from 'rxjs/Observable';
import {GeoSpreadPerAge} from './api.models';

export class StatisticsEndpoint extends Request {
    protected messagecentralId: number;

    constructor(http: Http, settings: Settings, messagecentralId: number) {
        super(http, settings);
        this.messagecentralId = messagecentralId;
    }

    geoSpreadPerAge(platform: string, groupBy?: string): Observable<GeoSpreadPerAge[]> {
        return this.get('/v1/messagecentrals/' + this.messagecentralId + '/proxy/profiles/statistics/geo-spread-per-age', this.createSearch({
            platform: platform,
            groupby: groupBy
        }));
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messagecentrals/proxy/statistics/api.service.ts